<template>
  <div class="range range--tooltip" style="margin-bottom:0!important;">
    <span class="d-flex align-content-center justify-content-between">
      <span>
        <span class="average-pence-per-mile d-block">{{ averagePencePerMile }}p</span>
        <span style="line-height:14px;display:block;">Illustrative Pence Per Mile</span>
        <VDropdown :disabled="!tooltip" class="flex-grow-1">
          <button class="tooltip-button"><i class="icon-info-solid"/></button>
          <template #popper>
            <p>This is the estimated monthly cost to charge the vehicle based on the details set in the charging profile. To amend the details, please click on Set charging profile.</p>
          </template>
        </VDropdown>
      </span>
      <span>
        <button aria-label="Set charging profile" @click.prevent="showChargingProfileForm"
          class="button button--xsmall button--steelBlue-ghost mt-2 float-end">
          Set charging profile
        </button>
      </span>
    </span>
  </div>
</template>

<script>
import {EventBus} from '@/event-bus.js';

export default {
  name: "estimated-electric-costs",
  props: [
    "quote",
    "averagePencePerMile"
  ],
  data() {
    return {
      tooltip: true,
    }
  },
  methods: {
    showChargingProfileForm() {
      EventBus.$emit('charging-slideout-visible');
    },
    showSlideout() {
      EventBus.$emit('slideout-visible', this.quote.quoteID);
    },
    hideSlideout() {
      EventBus.$emit('slideout-visible', false);
    },
  }
}
</script>
